import React, {Suspense, useState} from 'react';

import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {useNotebookQuotaModalStore} from './notebookQuotaModalStore';

const {Component: LazyNotebookQuotaModal} = createPreloadableLazyComponent(
  () => import('./NotebookQuotaModal'),
  module => module.NotebookQuotaModal
);

/**
 * The App-root mount for the quota dialog. It subscribes only to whether a
 * refusal exists, so the dialog's module (and its component-library imports)
 * stays out of the boot path and loads on the first refusal. Once loaded it
 * stays mounted, so a later dismissal can still play the exit transition.
 */
export function NotebookQuotaModalHost() {
  const hasRefusal = useNotebookQuotaModalStore(state => state.refusal != null);
  const [loaded, setLoaded] = useState(false);
  if (hasRefusal && !loaded) {
    setLoaded(true);
  }
  if (!loaded) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <LazyNotebookQuotaModal />
    </Suspense>
  );
}
